module.exports = __webpack_public_path__ + "img/under-construction.0125f898.svg";